export default class BlockCaseStudies {
	static init() {

		let blocks = document.querySelectorAll('.block-case-studies');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper');
			const pagination = block.querySelector('.swiper-pagination');
			const navigationPrev = block.querySelector('.swiper-btn-prev');
			const navigationNext = block.querySelector('.swiper-btn-next');
			new Swiper(swiper, {
				slidesPerView: 1,
				breakpoints: {
					769: {
						slidesPerView: 2
					},
					992: {
						slidesPerView: 3
					}
				},
				grabCursor: true,
				spaceBetween : 30,
				navigation: {
					nextEl: navigationNext,
					prevEl: navigationPrev
				},
				pagination: {
					el: pagination,
					type: 'bullets',
					bulletElement: 'span',
					clickable: true
				}
			});
		});
	}
}
